
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/ziflow-pricing",
      function () {
        return require("private-next-pages/comparisons/ziflow-pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/ziflow-pricing"])
      });
    }
  